import { ChangeDetectorRef, Component, OnInit, Inject, Renderer2, ViewChild, TemplateRef, NgZone } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from '@app/core/services/notification/notification.service';
import { BraintreeService } from '@app/shared/services/braintree/braintree.service';
import { LazyloadjsService } from '@app/shared/services/lazyloadjs/lazyloadjs.service';
import { AddressService } from '@app/shared/services/address/address.service';
import { FilterList, FilterModel, ProductList } from '@app/shared/models/product';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { ProductService } from '@app/shared/services/product/product.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { InksofteditorAPIInterface, InksofteditorInterfaceData, ProductShopifyInterface, BulkInventory } from '@app/shared/components/inksofteditor/inksofteditor.interface';
import { DomSanitizer } from '@angular/platform-browser';
import { InksoftService } from '@app/shared/services/inksoft/inksoft.service';
import { ColorModel } from '@app/shared/models/color';
import { ICustomizedProductDetailsInterface, Size, Style, StyleShopify } from '@app/feature/store-admin/components/add-product-popup/IcustomizedProductDetails.interface';
import { StoreService } from '@app/feature/store-admin/services/store.service';
import { environment } from '@env/environment';
import { HttpClient } from '@angular/common/http';
import { StorePublishModel } from '@app/shared/models/storepublish';
import { IStoreListInterface, ResponseData } from '@app/feature/store-admin/components/add-product-popup/IStoreList.interface';
import { CreateStoreComponent } from '@app/feature/store-admin/components/create-store/create-store.component';
import { InksoftGetListService } from '@app/shared/services/inksoftGetList/inksoft-get-list.service';
import { GetStoreListInterface } from '@app/feature/store-admin/services/GetStoreList.interface';
import { AnimationKeyframesSequenceMetadata } from '@angular/animations';
import { ProductGetById } from '../../../../shared/services/product/uploadProductImages.interface';
import { Route, Router, ActivatedRoute } from '@angular/router';
import { DesignModel } from '@app/shared/models/design';
import { StateService } from '@app/shared/services/state/state.service';
import { Constants, CryptoKeyValue } from '@app/shared/constants';
import { DragCanvasComponent } from '@app/shared/components/drag-canvas/drag-canvas.component';
import { CommonService } from '@app/shared/services/common/common.service';
import { InksoftDesignModel } from '@app/shared/models/InksoftDesignModel';
import { IClientAuthorizeCallbackData, ICreateOrderRequest, IPayPalConfig, NgxPayPalModule } from 'ngx-paypal';
import { EncrDecrService } from '../../../../shared/services/encr-decr-service.service';
import { ShopifyCollectionService } from '../../../super-admin/services/shopifyCollection/shopify-collection.service';
import { CurrencyPipe } from '@angular/common';
import { LocalStorageService } from '@app/core/services/localStorage/local-storage.service';
import { IUserLocalDetails } from '@app/core/services/localStorage/Ilocal-storage.interface';

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}
export interface ManualPayment {
  PaymentId: string;
  PayerId: string;
  DesignId: string;
}
export interface PricingTable {
  select: Boolean;
  styleId: number;
  uniqueStyleId: number;
  imageUrl: string;
  color: String;
  colorName: string;
  sizeName: string;
  uniqueSizeId: string;
  price: number;
  printCost: number;
  finishingCost: number;
  retailPrice: number;
  discountedPrice: number;
  SizingLabelData: any;
  FinishingPrice: number;
  EmbroideryCost: number;
  EmbroiderySetUpCost: number;
  bulkPerSizeQuantity: number;
  bulkPrice: number;
  totalbulkPrice: number;

  sideCount: number;
  discountPercantage: number;

  // only For shopify
}
export interface UpdateDesignWithSelectedColors {
  DesignId: number;
  ColorsJson: string | string[];
  ShopifyProfit: number;
  StoreId: number;
  SizingLabelData: any;
  FinishingPrice: number;
  UserId: number;
  CreatedBy: number;
  Metadata: string;
  Tags: string;
  Styles: SelectedProductStyleModel[]
}
export interface ShopifyVariants {
  option1: string;
  option2: string;
  inventory_policy: string;
  price: number;
  cost: number;
}
export interface DesignProductTabs {
  options: boolean;
  customizeProduct: boolean;
  sizingLabel: boolean;
  pricing: boolean;
  selectStore: boolean;
  payment?: boolean;
}
export interface SavedDesignfilterModel {
  Take: number;
  Skip: number;
  Email: any;
  IsShopifyProduct?: boolean;
}
export interface SelectedProductStyleModel {
  styleId: number;
  uniqueStyleId: number;
  // product styles can have seperate design id
  designId: number;
}

@Component({
  selector: "app-add-product-popup",
  templateUrl: "./add-product-popup.component.html",
  styleUrls: ["./add-product-popup.component.css"],
})
export class AddProductPopupComponent implements OnInit {
  // DialogueData: any;
  IsPublished: boolean = true;
  shopifyRequestData: ProductShopifyInterface | undefined;
  selctedColor: any;
  getProductById: ProductGetById;
  storeIdForEdit: any;
  shopifyStoreApiKey: string;
  isEditCase: boolean = false;
  isProductReplaceCase: boolean = false;
  @ViewChild(DragCanvasComponent) canvasComp: DragCanvasComponent;
  mySavedDesignList!: any[];
  bulkproduct: BulkInventory[] = [];
  throttle = 100;
  scrollDistance = 2;
  savedSizeLabelCount = 0;
  isSavedSizeLabelDisplayed: boolean = false;
  IsEmbroideryType: boolean = false;
  IsBulkUploadType: boolean = false;
  flag: boolean = false;
  isDisabled: boolean = false;
  listSummary: any[];
  showSummary: boolean = false;
  BulkDiscount: any[];
  totalQuantity = 0;
  decPercentage = 0;
  storeName!: any;
  public payPalConfig?: IPayPalConfig;
  totalCosttoCharge: any;
  totalCost: any;
  discountedPrice: any;
  manualPayment!: ManualPayment;
  totalqunatity: any;
  companyId: number;
  superAdminLoggedIn: boolean = false;
  superadminUserId: any = 0;
  storeOwnerUserId: any = 0;
  detailText = {
    text: "",
    description: "",
  };
  productSizeGuide: any = null;
  productSupplier: string = null;
  productLabels: any[] = [
    { text: "", backgroundColor: "#24afb2", textColor: "#ffffff" },
  ];
  productTags: any[] = [{ tagtext: "" }];
  DecorationType: string = null;
  PngRelativeUrlWithProduct = "";
  metaFieldId: number = null;
  tagsId: number = null;

  // Original requester info (kept for backwards compat with stateService data shape)
  originalCreatedBy: number | null = null;
  originalApplicationUserId: number | null = null;
  originalInkSoftUserId: number | null = null;

  // InkSoft login state - used to wait for loginInksoft() before showing editor
  private inksoftReady: boolean = false;
  private pendingEditorNavigation: boolean = false;

  constructor(
    // public dialogRef: MatDialogRef<AddProductPopupComponent>,
    public dialog: MatDialog,
    private notificationService: NotificationService,
    private commonService: CommonService,
    private loader: LoaderService,
    private productservice: ProductService,
    private errorhandlerService: ErrorhandlerService,
    private sanitizer: DomSanitizer,
    private inksoftService: InksoftService,
    private inksoftGetListService: InksoftGetListService,
    private storeService: StoreService,
    private fb: FormBuilder,
    private productService: ProductService,
    private changeDetectorRefs: ChangeDetectorRef,
    private router: Router,
    private renderer2: Renderer2,
    private stateService: StateService,
    private zone: NgZone,
    private activatedRoute: ActivatedRoute,
    private EncrDecr: EncrDecrService,
    private cp: CurrencyPipe,
    private localStorage: LocalStorageService,
    private shopifyCollectionService: ShopifyCollectionService
  ) {
    this.storeForm = this.fb.group({
      selectedStore: ["", Validators.required],
    });
    //if (this.activatedRoute.parent) {
    //  this.activatedRoute.parent.params.subscribe(params => {
    //    this.parentRouteParam = params['storename'];
    //  })
    //}
    this.storeName = this.activatedRoute.snapshot.queryParams["storeName"];
    this.mySavedDesignList = [];
  }

  shopifyProduct: boolean;
  shopifyProfit: any;
  public listPanels: DesignProductTabs = {
    options: true,
    customizeProduct: false,
    sizingLabel: false,
    pricing: false,
    selectStore: false,
    payment: false,
  };
  public listPanelHeaders: DesignProductTabs = {
    options: true,
    customizeProduct: true,
    sizingLabel: true,
    pricing: true,
    selectStore: true,
  };
  pageSize = 100; // No of items to load from server side i.e no of items to take
  savedDesignFilter: SavedDesignfilterModel;
  selectProduct: InksofteditorInterfaceData | null = null;
  ProductCustomized: {
    ID: number;
    nbOfSides: number;
    prices: Style[];
    colorList: {
      colorCode: string;
      colorName: string;
      png: string;
    };
    name: string;
    unitCost: number;
    retailPrice: number;
    printingCost: number;
    longDescription: string;
    shopifyprofit: boolean;
    savedStyle: {
      UniqueStyleId: string;
      DesignId: number;
    }[];
    PngRelativeUrlWithProduct: string;
    productUniqueId: number;
    designId: number;
    DiscountPercent: number;
    Images: {
      ImagePath: string;
      UniqueStyleId: number;
      IsCustom: boolean;
    }[];
  };
  ProductCustomizedShopify: {
    ID: number;
    nbOfSides: number;
    prices: StyleShopify[];
    colorList: {
      colorCode: string;
      colorName: string;
      png: string;
    };
    name: string;
    unitCost: number;
    retailPrice: number;
    printCost: number;
    longDescription: string;
    shopifyprofit: boolean;
    savedStyle: {
      UniqueStyleId: string;
      DesignId: number;
    }[];
    PngRelativeUrlWithProduct: string;
    productUniqueId: number;
    designId: number;
    DiscountPercent: number;
    Images: {
      ImagePath: string;
      UniqueStyleId: number;
      IsCustom: boolean;
    }[];
    FinishingPrice: number;
    EmbroideryCost: number;
  };
  //Defualt Setting to show of
  SizingLabelData = {
    //DesignID, Sizes are getting the backend by querying db
    CanvasBlob: null, //ImagePath, FileName are created at BE
    MadeIn: null,
    Composition: [],
    RN: null,
    Tagline1: null,
    Tagline2: null,
    FontStyle: "ArialBlack", //TimesBold,  ScriptMTBold
    AddSizeLevel: false,
    UpdateSizeLevel: false,
    EnableSizingLabel: false,
    Enable_BulkOrder: false,
  };
  BulkQrder: BulkInventory;
  displayedColumns: string[] = [
    "select",
    "color",
    "colorName",
    "sizeName",
    "price",
    "retailPrice",
  ];
  dataPricingSize: PricingTable[] = [];
  profitPrice = 0;
  finishingCost = 0;
  ApplicationUserId: any;
  storeList!: GetStoreListInterface[];
  storeForm: FormGroup;
  selectedStore = 0;
  designId: any;
  styleId: any;
  designIdNew: any;
  ProductIdOld: any;
  CustomizedProductId: any;
  storePublishModel!: any;
  showCustomPage = false;
  iframeURL: any;
  oneTimeTrigger = false;
  selectedProductStyleIds: SelectedProductStyleModel[] = [];
  existingSizingLabelImage: string;
  discountPercentage: number;
  additionalPrintCost: number = 0;
  EmbroideryCost: number = 0;
  EmbroiderySetUpCost: number = 0;
  masterProductImgBaseURL: string;

  // Design Huddle integration
  editorSelected: boolean = false;
  selectedEditor: 'inksoft' | 'designhuddle' = null;
  @ViewChild("imageDialog") imageDialog: TemplateRef<any>;
  @ViewChild("designVariantDialog") designVariantDialog: TemplateRef<any>;
  designVariantDialogRef: MatDialogRef<any>;
  sizelabelInfoMessage: string =
    "Edit button appears after sizing label gets generated in case sizing label has been selected.";
  IsBulkUploadOrder: boolean = false;

  trustedUrl(url: string) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  ngOnInit() {
    if (this.router.url.includes("superadmin/shopify-products-add-product")) {
      this.superAdminLoggedIn =
        localStorage.getItem("role") === "SuperAdmin" ||
        localStorage.getItem("role") === "CustomerService";
      this.shopifyProduct = true;

      // Start InkSoft login (async) — sets inksoftReady flag when done
      this.loginInksoft();
    }

    this.initAfterLogin();
  }

  private initAfterLogin() {
    let data = this.stateService.addProductPopupdata;
    this.stateService.addProductPopupdata = undefined;

    let selectP = this.stateService.selectedProduct;
    this.stateService.selectedProduct = undefined;
    this.initialize();

    if (data && data.haveNoStyles) {
      // this.designIdNew = data.designIdNew;
      this.designId = data.designId;
      this.IsPublished = data.IsPublished;
      this.selectProduct = {
        productId: data.ProductId,
        categoryId: "",
        styleId: "",
        designId: "",
        sizes: data.Sizes,
        additionalInfo: data.ProductAdditionalInfo,
        sizingLabelExist: data.SizingLabelExist,
      };
      this.existingSizingLabelImage = data.SizingLabelImage;
      this.buildSizingData();
      this.oneTimeTrigger = false;
      this.updatePricePanel();
      if (this.SizingLabelData.EnableSizingLabel) {
        this.nextPanel("sizingLabel");
      } else {
        this.nextPanel("pricing");
      }
    } else if (data && data.isEditCase) {
      this.ProductIdOld = data.ProductIdOld;
      this.designId = data.designId;
      this.styleId = data.styleId;
      this.isEditCase = true;
      this.isProductReplaceCase = data.isProductReplaceCase;
      this.shopifyProduct = data.shopifyProduct;
      this.listPanelHeaders.selectStore = false;

      if (this.isProductReplaceCase) {
        // this.fn_GetProducts();
        // For now we are not calling this may be later on we do, so commiting it for now
        //this.fn_GetFilters();
      } else {
        this.selectProduct = {
          productId: this.ProductIdOld,
          categoryId: "",
          styleId: this.styleId,
          designId: this.designId,
          sizes: data.Sizes,
          url: "",
          additionalInfo: data.ProductAdditionalInfo,
          sizingLabelExist: data.SizingLabelExist,
        };
        this.existingSizingLabelImage = data.SizingLabelImage;
        this.buildSizingData();
        if (this.IsEmbroideryType && this.isEditCase) {
          if (this.SizingLabelData.EnableSizingLabel) {
            this.nextPanel("sizingLabel");
          } else {
            this.nextPanel("pricing");
          }
        } else this.nextPanel("customizeProduct");
      }
    } else if (selectP && selectP.productId) {
      // if customize button clicked from Master product listing or master product detail page
      this.selectProduct = selectP;
      this.buildSizingData();
      this.nextPanel("customizeProduct");
    } else {
      // this.fn_GetProducts();
      // For now we are not calling this may be later on we do, so commiting it for now
      //this.fn_GetFilters();
    }
  }
  initialize() {
    this.savedSizeLabelCount = 0;
    this.masterProductImgBaseURL = environment.masterProductImgBaseURL;
    this.ApplicationUserId = localStorage.getItem("userId");

    this.selectProduct = {
      productId: "",
      categoryId: "",
      styleId: "",
      designId: "",
      sizes: [],
      url: "",
      additionalInfo: null,
      sizingLabelExist: false,
    };
    this.savedDesignFilter = {
      Skip: 0,
      Take: 5,
      Email: "",
      IsShopifyProduct: null,
    };
    this.manualPayment = {
      PayerId: "",
      PaymentId: "",
      DesignId: "",
    };
  }
  buildSizingData() {
    if (this.selectProduct.additionalInfo) {
      this.SizingLabelData = {
        ...this.SizingLabelData,
        MadeIn: this.selectProduct.additionalInfo.MadeIn,
        RN: this.selectProduct.additionalInfo.RN,
        Composition: this.selectProduct.additionalInfo.Composition
          ? this.selectProduct.additionalInfo.Composition.split(",")
          : [],
        EnableSizingLabel:
          this.selectProduct.additionalInfo.Enable_Sizing_Label,
      };
      this.IsEmbroideryType =
        this.selectProduct.additionalInfo.Enable_Embroidery;
      this.IsBulkUploadType =
        this.selectProduct.additionalInfo.Enable_BulkOrder;
    }
  }
  updatePricePanel() {

    //customer service or super admin trying to add the shopify product
    if (this.superAdminLoggedIn && !this.isEditCase && this.shopifyProduct) {
      this.getProductById = {
        productId: Number(this.selectProduct.productId),
        designId: this.designId,
        storeId: this.activatedRoute.snapshot.queryParams["storeId"],
      };
      this.getCustomizedProductDetailsWithStyle(this.getProductById);
    }
    //customer service or super admin trying to edit the shopify product
    if (this.superAdminLoggedIn && this.isEditCase && this.shopifyProduct) {
      this.getProductById = {
        productId: Number(this.selectProduct.productId),
        designId: this.designIdNew,
        storeId: this.activatedRoute.snapshot.queryParams["storeId"],
      };
      this.storeIdForEdit = this.activatedRoute.snapshot.queryParams["storeId"];
      this.getCustomizedProductDetailsWithStyle(this.getProductById);
    }


    if (this.shopifyProduct && !this.superAdminLoggedIn) {
      //this comes from store admin to update the shopify product from there thats why newDesignId is passed
      this.productService
        .getShopifyStoreKey({ designId: this.designId })
        .subscribe((res: any) => {
          if (res.StatusCode == 200) {
            this.storeIdForEdit = res.StoreID;
            this.shopifyStoreApiKey = res.apikey;
            this.getProductById = {
              productId: Number(this.selectProduct.productId),
              designId: this.designIdNew,
              storeId: this.activatedRoute.snapshot.queryParams["storeId"],
            };
            this.getCustomizedProductDetailsWithStyle(this.getProductById);
          }
        });
    }

    if (!this.shopifyProduct && !this.superAdminLoggedIn) {
      //if the user is store admin and the product is not a type of shopify product
      if (this.designIdNew > 0 && this.designIdNew != undefined)
        //edit case
        this.getCustomizedProductDetails(
          this.selectProduct.productId,
          this.designIdNew
        );
      else
        //add case
        this.getCustomizedProductDetails(
          this.selectProduct.productId,
          this.designId
        );
    }
  }
  selectStorePanel() {
    if (this.selectedProductStyleIds.length > 0) {
      if (!this.superAdminLoggedIn) {
        this.fn_getStoreList();
        this.nextPanel("selectStore");
      } else {
        this.nextPanel("selectStore");
      }
    } else {
      this.notificationService.error(
        "Please select at least one color",
        "Validation error"
      );
    }
  }
  saveShopifyData() {
    this.loader.show();
    var colorsData = this.updateDesignWithSelectedColorsFn(this.designIdNew);
    
    this.productService.updateCustomizedDesign(colorsData).subscribe(async (res) => {
      //get here the exact images to be passed to shopify
      this.ProductCustomizedShopify.Images = res.Data.ResponseData1,
      this.mapShopifyRequestData();

      // Fetch store's assigned collection and add to request before publishing
      const publishStoreId = this.activatedRoute.snapshot.queryParams["storeId"] || this.storeIdForEdit;
      if (publishStoreId) {
        try {
          const colRes: any = await this.shopifyCollectionService.getStoreCollectionId(Number(publishStoreId)).toPromise();
          if (colRes?.StatusCode === 200 && colRes?.Data?.ResponseData) {
            this.shopifyRequestData.shopifyCollectionId = colRes.Data.ResponseData;
          }
        } catch (e) {
          // ignore — publish without collection
        }
      }

      if (res.StatusCode == 200) {
        // ===== SHOPIFY PUBLISH TEMPORARILY DISABLED =====
        // We keep the MerchLoop DB writes (updateCustomizedDesign above + updateThePrice below,
        // product stays active) but do NOT push the change to Shopify.
        // if isProductReplaceCase = true in case of edit (means product is changed) then do replace product
        if (this.isProductReplaceCase && this.isEditCase) {
          this.updateThePrice(
            this.ProductCustomizedShopify.ID.toString(),
            this.storeIdForEdit.toString(),
            this.profitPrice.toString(),
            true,
            null
          );
          this.notificationService.success(
            "Product saved successfully (Shopify publish disabled)",
            "Success"
          );
          this.notificationService.infoAlways(this.sizelabelInfoMessage, "");
          this.router.navigate(["store/customizedproducts"]);
          /* ===== Shopify publish disabled - original code kept for re-enable =====
          this.productService
            .replaceProductInShopify(this.shopifyRequestData)
            .subscribe((res) => {
              this.updateThePrice(
                this.ProductCustomizedShopify.ID.toString(),
                this.storeIdForEdit.toString(),
                this.profitPrice.toString(),
                true,
                null
              );
              this.notificationService.success(
                "Product successfully updated in shopify",
                "Success"
              );
              this.notificationService.infoAlways(
                this.sizelabelInfoMessage,
                ""
              );
              this.router.navigate(["store/customizedproducts"]);
            });
          ===== end Shopify publish disabled ===== */
        }
        // if isProductReplaceCase = false in case of edit (it means only design changed) then do update product
        else if (!this.isProductReplaceCase && this.isEditCase) {
          const oldDesignId = this.selectProduct.designId;
          const storeId =
            this.activatedRoute.snapshot.queryParams["storeId"];
          this.updateThePrice(
            this.ProductCustomizedShopify.ID.toString(),
            storeId,
            this.profitPrice.toString(),
            false,
            oldDesignId
          );
          this.notificationService.success(
            "Product saved successfully (Shopify publish disabled)",
            "Success"
          );
          this.notificationService.infoAlways(this.sizelabelInfoMessage, "");
          if (this.shopifyProduct && this.superAdminLoggedIn) {
            const storeid =
              this.activatedRoute.snapshot.queryParams["storeId"];
            const storeName =
              this.activatedRoute.snapshot.queryParams["storeName"];
            this.router.navigate([
              "superadmin/shopify-products",
              storeid,
              storeName,
            ]);
          } else this.router.navigate(["store/customizedproducts"]);
          /* ===== Shopify publish disabled - original code kept for re-enable =====
          this.productService
            .UpdateProductInShopify(this.shopifyRequestData)
            .subscribe((res) => {
              const oldDesignId = this.selectProduct.designId;
              const storeId =
                this.activatedRoute.snapshot.queryParams["storeId"];
              this.updateThePrice(
                this.ProductCustomizedShopify.ID.toString(),
                storeId,
                this.profitPrice.toString(),
                false,
                oldDesignId
              );
              this.notificationService.success(
                "Product successfully updated in shopify",
                "Success"
              );
              this.notificationService.infoAlways(
                this.sizelabelInfoMessage,
                ""
              );
              if (this.shopifyProduct && this.superAdminLoggedIn) {
                const storeid =
                  this.activatedRoute.snapshot.queryParams["storeId"];
                const storeName =
                  this.activatedRoute.snapshot.queryParams["storeName"];
                this.router.navigate([
                  "superadmin/shopify-products",
                  storeid,
                  storeName,
                ]);
              }
              else this.router.navigate(["store/customizedproducts"]);
            });
          ===== end Shopify publish disabled ===== */
        }
      }
    });
  }
  saveInksoftData() {
    this.loader.show();
    let isfirstTime = false; // if product is created first time or replaced
    let oldDesignId: string = null;
    if (this.isProductReplaceCase && this.isEditCase) {
      isfirstTime = true;
    } else if (!this.isProductReplaceCase && this.isEditCase) {
      isfirstTime = false;
      oldDesignId = this.selectProduct.designId;
    }
    this.updateThePrice(
      this.ProductCustomized.ID.toString(),
      this.storeIdForEdit.toString(),
      this.profitPrice.toString(),
      isfirstTime,
      oldDesignId
    );
    this.notificationService.success("Product updated successfully", "Success");
    this.notificationService.infoAlways(this.sizelabelInfoMessage, "");
    this.router.navigate(["store/customizedproducts"]);
  }
  updateDesignWithSelectedColorsFn(
    designID: number
  ): UpdateDesignWithSelectedColors {
    const colors = this.ProductCustomizedShopify.prices.reduce((init, sty) => {
      if (this.selectedProductStyleIds.some((s) => s.styleId == sty.StyleId)) {
        return [...init, ...sty.StyleColor];
      } else {
        return init;
      }
    }, []);
    return {
      DesignId: designID,
      ShopifyProfit: this.profitPrice,
      ColorsJson: JSON.stringify(colors),
      StoreId: this.activatedRoute.snapshot.queryParams["storeId"],
      SizingLabelData: this.SizingLabelData,
      FinishingPrice: this.finishingCost,
      UserId: this.ApplicationUserId,
      Styles: this.selectedProductStyleIds,
      CreatedBy: this.superAdminLoggedIn
        ? this.superadminUserId
        : this.ApplicationUserId,
      Metadata: this.fn_GetMetaFieldsToSaveInDb(),
      Tags: this.fn_GetTagsToSaveInDb(),
    };
  }

  loopToSaveDesign(designId: number, copiedDesignId: number) {
    const applicationUserId = this.ApplicationUserId;
    const createdBy = this.superAdminLoggedIn ? this.superadminUserId : this.ApplicationUserId;

    let designModel: DesignModel = {
      DesignId: 0,
      ApplicationUserId: applicationUserId,
      CreatedBy: createdBy,
      ProductId: this.selectProduct.productId,
      StyleId: this.selectProduct.styleId,
      UniqueStyleId: this.selectProduct.styleId, // Pass styleId as UniqueStyleId (in product request mode, styleId is already the UniqueStyleId)
      IsEmbroideryType: this.IsEmbroideryType,
      IsBulkUploadType: this.IsBulkUploadType,
      CopiedDesignId: copiedDesignId,
    };

    if (this.isEditCase) {
      designModel = {
        ...designModel,
        ProductId: this.ProductIdOld,
        NewProductId: this.selectProduct.productId,
        DesignId: this.selectProduct.designId,
        NewDesignId: designId,
        IsEmbroideryType: this.IsEmbroideryType,
        IsBulkUploadType: this.IsBulkUploadType,
      };
      if (!this.isProductReplaceCase) designModel.NewProductId = null;
    } else {
      designModel = {
        ...designModel,
        DesignId: designId,
      };
    }
    this.inksoftService.saveCustomizedDesign(designModel).subscribe(
      (res: any) => {
        if (res.Message === "Success" || res.StatusCode === 200) {
          this.notificationService.success(
            "Product customized successfully",
            "Customization"
          );
          this.updatePricePanel();
          this.loader.hide();
        } else if (res.StatusCode === 400) {
          this.loopToSaveDesign(designId, null);
        } else {
          this.loopToSaveDesign(designId, null);
        }
      },
      (err: any) => {
        this.errorhandlerService.handleError(err);
        // this.loader.hide();
      }
    );
  }

  fn_SaveDesign(designData: any) {
    this.oneTimeTrigger = false;
    this.zone.run(() => {
      this.loader.show();
    });
    if (this.isEditCase) {
      this.designIdNew = designData.ID;
    } else {
      this.designId = designData.ID;
    }
    this.loopToSaveDesign(designData.ID, designData.OldDesignId);
    this.buildSizingData();
    if (this.SizingLabelData.EnableSizingLabel) {
      this.nextPanel("sizingLabel");
    } else {
      this.nextPanel("pricing");
    }
  }

  /** Opens inksoft editor for customizing a product */
  fn_CustomizeProduct(incProduct: InksofteditorInterfaceData) {

    if (
      (this.designId === null || this.designId === undefined) &&
      incProduct.designId
    ) {
      this.designId = incProduct.designId;
    } // we have added this condition to check wether the design is existing or new.
    this.selectProduct = {
      categoryId: incProduct.categoryId,
      productId: incProduct.productId,
      styleId: incProduct.styleId,
      url: incProduct.url,
      designId: this.designId,
      sizes: incProduct.sizes,
      additionalInfo: incProduct.additionalInfo,
      sizingLabelExist: false,
    };
    this.buildSizingData();
    this.nextPanel("customizeProduct");
  }

  nextPanel(showPanel: string) {
    if (this.SizingLabelData.UpdateSizeLevel)
      this.SizingLabelData.AddSizeLevel = true;

    if (showPanel == "pricing" && this.SizingLabelData.AddSizeLevel) {
      this.fn_calculateFinshingCost(this.finishingCost);
      // this.updatePricing();
      this.canvasComp.resetCanvas();
      setTimeout(() => {
        this.nextPricingPanel(showPanel);
      }, 500);
    } else {
      if (!this.SizingLabelData.AddSizeLevel && showPanel == "pricing") {
        this.fn_calculateFinshingCost(this.finishingCost);
        if (this.shopifyProduct && this.IsEmbroideryType) {
          this.designIdNew = this.designId;
          this.updatePricePanel();
        } else if (this.designIdNew > 0 && this.designIdNew != undefined)
          this.getCustomizedProductDetails(
            this.selectProduct.productId,
            this.designIdNew
          );
        else
          this.getCustomizedProductDetails(
            this.selectProduct.productId,
            this.designId
          );
        // if (!this.shopifyProduct) {
        //   this.getCustomizedProductDetails(this.ProductIdOld, this.designIdNew);
        // }
        // this.updatePricing();
      }
      for (const panel in this.listPanels) {
        if (this.listPanels.hasOwnProperty(panel)) {
          this.listPanels[panel] = false;
        }
      }
      this.showCustomPage = showPanel === "customizeProduct";
      this.listPanels[showPanel] = true;
    }
  }

  nextPricingPanel(showPanel: string) {
    this.finishingCost = Constants.finishingCost;
    this.updatePricePanel();
    this.loader.show();
    const dataURL = this.canvasComp.fetchImageDataURL();
    this.SizingLabelData.CanvasBlob = dataURL;
    for (const panel in this.listPanels) {
      if (this.listPanels.hasOwnProperty(panel)) {
        this.listPanels[panel] = false;
      }
    }
    this.showCustomPage = showPanel === "customizeProduct";
    this.listPanels[showPanel] = true;
    this.loader.hide();
  }

  getCustomizedProductDetailsWithStyle(getProductById: any) {
    this.productservice
      .getCustomizedProductDetailsWithStyle(getProductById)
      .subscribe(
        (res: any) => {
          if (res.StatusCode === 200 && res.Data.ResponseData.length > 0) {
            // Find the correct CustomizedProduct by ID if available (for edit case)
            // API may return multiple CustomizedProducts for same ProductId/DesignId
            let dataItem = res.Data.ResponseData[0];
            if (this.CustomizedProductId && res.Data.ResponseData.length > 1) {
              const found = res.Data.ResponseData.find(
                (item: any) => item.CustomizedProductId === this.CustomizedProductId
              );
              if (found) {
                dataItem = found;
              }
            }

            this.profitPrice = dataItem.ShopifyProfit;
            this.shopifyProfit = dataItem.ShopifyProfit;
            this.PngRelativeUrlWithProduct = dataItem.PngRelativeUrlWithProduct,
            this.selctedColor = JSON.parse(dataItem.ColorsJson);
            this.detailText.text = dataItem.Name;
            this.detailText.description =
              dataItem.ProductDescription.LongDescription;
            this.productSizeGuide = dataItem.SizeGuide;
            this.productSupplier = dataItem.Supplier;
            this.DecorationType = dataItem.ProductAdditionalInfo?.DecorationType;
            // this.finishingCost = dataItem.FinshingPrice;
            if (this.selctedColor == null) this.selctedColor = [];
            this.ProductCustomizedShopify = {
              ID: dataItem.CustomizedProductId,
              nbOfSides: res.Data.ResponseData.length,
              prices: dataItem.StyleList.filter(
                (x) => x.IsActive == true
              ),
              colorList: {
                colorCode: "#" + dataItem.StyleColor,
                colorName: dataItem.StyleName,
                png:
                  this.masterProductImgBaseURL +
                  dataItem.PngRelativeUrlWithProduct,
              },
              name: dataItem.Name,
              unitCost:
                isNaN(dataItem.Sizes[0].UnitPrice) == true
                  ? 0
                  : dataItem.Sizes[0].UnitPrice,
              retailPrice:
                isNaN(dataItem.RetailPrice) == true
                  ? 0
                  : dataItem.RetailPrice,
              shopifyprofit: dataItem.ShopifyProfit,
              longDescription:
                dataItem.ProductDescription.LongDescription,
              // printingCost: dataItem.PrintingCost === 0 ? 5 : dataItem.PrintingCost,
              EmbroideryCost: dataItem.EmbroideryCost,
              //EmbroiderySetUpCost: dataItem.EmbroiderySetUpCost,
              printCost:
                dataItem.PrintingCost === 0
                  ? 5
                  : dataItem.PrintingCost,
              savedStyle: dataItem.SavedStyles.map((ele) => {
                return {
                  UniqueStyleId: ele.UniqueStyleId,
                  DesignId: ele.DesignId > 0 ? ele.DesignId : null,
                };
              }),
              FinishingPrice: dataItem.FinshingPrice,
              PngRelativeUrlWithProduct:
                dataItem.PngRelativeUrlWithProduct,
              productUniqueId: dataItem.ProductId,
              designId: dataItem.DesignId,
              DiscountPercent: dataItem.Discount,
              Images: res.Data.ResponseData1,
            };

            if (dataItem.Tags != null) {
              let parsedTags = JSON.parse(dataItem.Tags);
              // Add decoration type as first tag if it exists
              if (this.DecorationType && parsedTags.length > 0 && parsedTags[0].tagtext) {
                // Check if first tag is decoration type, if not add it
                if (parsedTags[0].tagtext !== this.DecorationType) {
                  parsedTags.unshift({ tagtext: this.DecorationType, isDefault: true });
                } else {
                  parsedTags[0].isDefault = true;
                }
              } else if (this.DecorationType) {
                // No tags exist, add only decoration type
                parsedTags = [{ tagtext: this.DecorationType, isDefault: true }];
              }
              this.productTags = parsedTags;
            } else if (this.DecorationType) {
              // No tags in DB, initialize with decoration type
              this.productTags = [{ tagtext: this.DecorationType, isDefault: true }];
            }
            if (dataItem.ProductMetadata != null)
              this.productLabels = JSON.parse(dataItem.ProductMetadata);

            this.IsEmbroideryType = dataItem.IsEmbroideryType;
            this.EmbroideryCost = dataItem.EmbroideryCost;

            // Get the main design ID to use for styles without alternate designs
            const mainDesignId = this.designIdNew || this.designId || dataItem.DesignId;

            this.ProductCustomizedShopify.prices.forEach((element) => {
              // let selected = this.selctedColor.includes(element.StyleColor)
              let selected = this.ProductCustomizedShopify.savedStyle.find(
                (ele) => ele.UniqueStyleId == element.UniqueStyleId
              );
              if (selected) {
                // Use alternate design ID if exists, otherwise use main design ID
                const styleDesignId = selected.DesignId && selected.DesignId > 0
                  ? selected.DesignId
                  : mainDesignId;
                this.SelectProductStyle(
                  { checked: true },
                  element.StyleId,
                  Number(element.UniqueStyleId),
                  styleDesignId
                );
              } else {
                if (this.selectProduct.styleId == element.UniqueStyleId) {
                  // selected = true;
                  this.SelectProductStyle(
                    { checked: true },
                    element.StyleId,
                    Number(element.UniqueStyleId),
                    mainDesignId
                  );
                }
              }
            });

            this.updatePricingShopify();

            // for table rowspan
            this.cacheSpan("select", (d) => d.styleId);
            this.cacheSpan("color", (d) => d.color);
            this.cacheSpan("colorName", (d) => d.colorName);

            this.changeDetectorRefs.detectChanges();

            // this.loader.hide();
          } else {
            // this.loader.hide();
            this.notificationService.error("An error occured", "error");
          }
        },
        (err: any) => {
          // this.loader.hide();
          this.notificationService.error("An error occured", "error");
        }
      );
  }
  getCustomizedProductDetails(productId: string, designId: string) {
    this.productservice
      .getCustomizedProductDetailsByProductId(
        productId,
        designId,
        localStorage.getItem("storeId")
      )
      .subscribe(
        (res: any) => {
          if (res.StatusCode === 200 && res.Data.ResponseData.length > 0) {
            this.selctedColor = JSON.parse(res.Data.ResponseData[0].ColorsJson);
            this.IsPublished = res.Data.ResponseData[0].IsPublished,
              this.EmbroideryCost = res.Data.ResponseData[0].EmbroideryCost;
            this.EmbroiderySetUpCost = res.Data.ResponseData[0].EmbroiderySetUpCost;

            this.detailText.text = res.Data.ResponseData[0].Name;
            this.detailText.description = res.Data.ResponseData[0].ProductDescription[0].LongDescription;

            this.PngRelativeUrlWithProduct = res.Data.ResponseData[0].PngRelativeUrlWithProduct,
              this.productSizeGuide = res.Data.ResponseData[0].SizeGuide;
            this.productSupplier = res.Data.ResponseData[0].Supplier;
            this.DecorationType = res.Data.ResponseData[0].ProductAdditionalInfo?.DecorationType;
            this.ProductCustomized = {
              ID: res.Data.ResponseData[0].CustomizedProductId,
              nbOfSides: res.Data.ResponseData.length,
              prices: res.Data.ResponseData[0].Styles.filter(
                (x) => x.IsActive == true
              ),
              colorList: {
                colorCode: "#" + res.Data.ResponseData[0].StyleColor,
                colorName: res.Data.ResponseData[0].StyleName,
                png:
                  this.masterProductImgBaseURL +
                  res.Data.ResponseData[0].PngRelativeUrlWithProduct,
              },
              name: res.Data.ResponseData[0].Name,
              unitCost: res.Data.ResponseData[0].Sizes[0].UnitPrice,
              retailPrice: res.Data.ResponseData[0].RetailPrice,
              shopifyprofit: res.Data.ResponseData[0].ShopifyProfit,
              longDescription:
                res.Data.ResponseData[0].ProductDescription[0].LongDescription,
              printingCost:
                res.Data.ResponseData[0].PrintingCost === 0
                  ? 5
                  : res.Data.ResponseData[0].PrintingCost,
              savedStyle: res.Data.ResponseData[0].SavedStyles.map((ele) => {
                return {
                  UniqueStyleId: ele.UniqueStyleId,
                  DesignId: ele.DesignId > 0 ? ele.DesignId : null,
                };
              }),
              PngRelativeUrlWithProduct:
                res.Data.ResponseData[0].PngRelativeUrlWithProduct,
              productUniqueId: res.Data.ResponseData[0].ProductId,
              designId: res.Data.ResponseData[0].DesignId,
              DiscountPercent: res.Data.ResponseData[0].Discount,
              Images: res.Data.ResponseData1,
            };
            if (res.Data.ResponseData[0].Tags != null) {
              let parsedTags = JSON.parse(res.Data.ResponseData[0].Tags);
              // Add decoration type as first tag if it exists
              if (this.DecorationType && parsedTags.length > 0 && parsedTags[0].tagtext) {
                // Check if first tag is decoration type, if not add it
                if (parsedTags[0].tagtext !== this.DecorationType) {
                  parsedTags.unshift({ tagtext: this.DecorationType, isDefault: true });
                } else {
                  parsedTags[0].isDefault = true;
                }
              } else if (this.DecorationType) {
                // No tags exist, add only decoration type
                parsedTags = [{ tagtext: this.DecorationType, isDefault: true }];
              }
              this.productTags = parsedTags;
            } else if (this.DecorationType) {
              // No tags in DB, initialize with decoration type
              this.productTags = [{ tagtext: this.DecorationType, isDefault: true }];
            }
            if (res.Data.ResponseData[0].ProductMetadata != null)
              this.productLabels = JSON.parse(res.Data.ResponseData[0].ProductMetadata);

            this.IsEmbroideryType = res.Data.ResponseData[0].IsEmbroideryType;
            this.IsBulkUploadType =
              res.Data.ResponseData[0].ProductAdditionalInfo.Enable_BulkOrder;

            if (this.IsEmbroideryType) {
              this.displayedColumns = [
                "select",
                "color",
                "colorName",
                "sizeName",
                "price",
                "retailPrice",
              ];
            }
            this.profitPrice = res.Data.ResponseData[0].RetailPrice == null ? 0 : res.Data.ResponseData[0].RetailPrice;


            //this.finishingCost = res.Data.ResponseData[0].FinshingPrice == null ? 0 : res.Data.ResponseData[0].FinshingPrice,
            (this.storeIdForEdit = res.Data.ResponseData[0].StoreId),
              this.ProductCustomized.prices.forEach((element) => {
                if (!this.IsPublished) {
                  const selected =
                    res.Data.ResponseData[0].StyleId == element.UniqueStyleId
                      ? true
                      : false;
                  if (selected) {
                    this.SelectProductStyle(
                      { checked: true },
                      element.StyleId,
                      Number(element.UniqueStyleId),
                      null
                    );
                  }
                } else {
                  let defaultStyle =
                    res.Data.ResponseData[0].StyleId == element.UniqueStyleId
                      ? true
                      : false;
                  if (defaultStyle) {
                    localStorage.setItem(
                      "styleIdToBeDesigned",
                      element.UniqueStyleId
                    );
                  }
                  const selected = this.ProductCustomized.savedStyle.find(
                    (ele) => ele.UniqueStyleId == element.UniqueStyleId
                  );
                  if (selected) {
                    this.SelectProductStyle(
                      { checked: true },
                      element.StyleId,
                      Number(element.UniqueStyleId),
                      selected.DesignId
                    );
                  }
                }
              });

            this.updatePricing();

            // for table rowspan
            this.cacheSpan("select", (d) => d.styleId);
            this.cacheSpan("color", (d) => d.color);
            this.cacheSpan("colorName", (d) => d.colorName);

            this.changeDetectorRefs.detectChanges();

            // this.loader.hide();
          } else {
            // this.loader.hide();
            this.notificationService.error("An error occured", "error");
          }
        },
        (err: any) => {
          // this.loader.hide();
          this.notificationService.error("An error occured", "error");
        }
      );
  }

  mapShopifyRequestData() {

    let productId = Number(this.ProductIdOld);
    if (this.selectProduct && this.selectProduct.productId)
      // id product replaced then assign new productid
      productId = Number(this.selectProduct.productId);

    this.shopifyRequestData = {
      product: {
        title: this.detailText.text,
        body_html: this.getProductDescription(),
        vendor: "Merchloop",
        product_type: "Clothes",
        tags: this.fn_GetTags(),
        metafields: this.fn_GetMetaFields(),
        options: [
          {
            name: "Color",
            values: this.dataPricingSize
              .filter(
                (ele, index) =>
                  this.dataPricingSize.findIndex(
                    (obj) => obj.colorName === ele.colorName
                  ) === index
              )
              .map((x) => x.colorName),
          },
          {
            name: "Size",
            values: this.ProductCustomizedShopify.prices[0].Size.map(
              (size) => size.Name
            ),
          },
        ],
        variants: this.dataPricingSize.reduce((init, sty) => {
          let price = 0;
          if (this.IsEmbroideryType)
            price = this.commonService.fn_CalculateTotalCost(
              sty.price,
              this.finishingCost,
              this.EmbroideryCost,
              sty.sideCount,
              this.profitPrice,
              this.IsEmbroideryType
            );
          else
            price = this.commonService.fn_CalculateTotalCost(
              sty.price,
              this.finishingCost,
              sty.printCost,
              sty.sideCount,
              this.profitPrice
            );
          // Shopify saves price and cost SEPARATELY: `price` is the selling price (incl. profit) and
          // `cost` is the "Cost per item" (COGS) = product cost WITHOUT the store profit. Shopify then
          // shows the real profit as (price - cost). Do NOT apply the store DiscountPercent to the COGS:
          // SOP-hosted stores use DiscountPercent = 100, which zeroed the cost on every variant so Shopify
          // reported the whole price as profit (100% margin).
          let cost = price - this.profitPrice;
          const varient = {
            option1: sty.colorName,
            option2: sty.sizeName,
            inventory_policy: "continue",
            // price: (Number(sty.retailPrice) + this.finishingCost + this.EmbroideryCost).toFixed(2),
            // cost: (Number(sty.discountedPrice) + this.finishingCost + sty.EmbroideryCost).toFixed(2),
            price: price.toFixed(2),
            cost: cost.toFixed(2),
            uniqueStyleId: Number(sty.uniqueStyleId),
            uniqueSizeId: Number(sty.uniqueSizeId),
          };
          if (
            this.selectedProductStyleIds.some((s) => s.styleId == sty.styleId)
          ) {
            return [...init, varient];
          } else {
            return init;
          }
        }, []),
        images: [
          {
            // Stored value is an absolute Azure Blob URL post-migration; no host prefix needed.
            src: this.ProductCustomizedShopify.PngRelativeUrlWithProduct,
          },
        ],
      },
      productid: Number(this.designIdNew),
      productid_old: this.designId,
      Product_Id: productId,
      StoreId: this.activatedRoute.snapshot.queryParams["storeId"],
      apiKey: this.shopifyStoreApiKey,
      VariantImages: this.dataPricingSize.reduce((init, sty) => {
        let styleImages = this.ProductCustomizedShopify.Images.filter(
          (x) => x.UniqueStyleId == sty.uniqueStyleId && x.IsCustom == false
        ).map((x) => this.masterProductImgBaseURL + x.ImagePath);
        if (
          this.selectedProductStyleIds.some((s) => s.styleId == sty.styleId) &&
          styleImages &&
          styleImages.length > 0 &&
          !init.find((x) => x.StyleName == sty.colorName)
        ) {
          return [
            ...init,
            {
              StyleName: sty.colorName,
              Images: styleImages,
            },
          ];
        } else {
          return init;
        }
      }, []),
    };
  }

  updatePricing() {
    this.dataPricingSize = this.ProductCustomized.prices.reduce(
      (current, next) => {
        next.Sizes.forEach((size) => {
          const selectedStyle = this.selectedProductStyleIds.find(
            (s) => s.styleId == next.StyleId
          );
          let select = false;
          let show;
          let imageUrl = this.commonService.fn_getImageUrl(
            this.masterProductImgBaseURL +
            this.ProductCustomized.PngRelativeUrlWithProduct,
            next.StyleName
          );
          if (selectedStyle) {
            select = true;
            // if design id exist that means alternate design exist for this variant or style
            if (selectedStyle.designId) {
              const img = this.ProductCustomized.Images.find(
                (x) =>
                  x.UniqueStyleId == selectedStyle.uniqueStyleId &&
                  x.IsCustom == false
              );
              if (img) imageUrl = this.masterProductImgBaseURL + img.ImagePath;
            }
          }
          var priceWithPrintCost = 0;
          if (this.IsEmbroideryType) {
            priceWithPrintCost = this.commonService.fn_CalculateTotalCost(
              size.UnitPrice,
              this.finishingCost,
              this.EmbroideryCost,
              this.ProductCustomized.nbOfSides,
              this.profitPrice,
              this.IsEmbroideryType
            );
          } else {
            priceWithPrintCost = this.commonService.fn_CalculateTotalCost(
              size.UnitPrice,
              this.finishingCost,
              this.ProductCustomized.printingCost,
              this.ProductCustomized.nbOfSides,
              this.profitPrice
            );
          }
          //const priceWithPrintCost = size.UnitPrice + this.additionalPrintCost;
          const discountedPrice = this.commonService.fn_calculateDiscount(
            priceWithPrintCost,
            this.ProductCustomized.DiscountPercent
          );
          current.push({
            select: select,
            styleId: next.StyleId,
            uniqueStyleId: next.UniqueStyleId,
            imageUrl: imageUrl,
            color: next.ColorCode,
            colorName: next.StyleName,
            printCost: this.additionalPrintCost,
            finishingCost: this.finishingCost,
            sizeName: size.Name,
            uniqueSizeId: size.UniqueSizeId,
            price: size.UnitPrice,
            discountedPrice: discountedPrice, // for shopify only
            retailPrice: priceWithPrintCost,
            showQuantityEnabled: this.IsBulkUploadOrder,
            bulkPerSizeQuantity: 0,
            bulkPrice: priceWithPrintCost - discountedPrice,
            totalbulkPrice: priceWithPrintCost - discountedPrice,
          });
        });
        return current;
      },
      []
    );
  }

  updatePricingShopify() {
    this.dataPricingSize = this.ProductCustomizedShopify.prices.reduce(
      (current, next) => {
        next.Size.forEach((size) => {
          let additionalPrintCost = 0;
          // if (this.ProductCustomizedShopify.nbOfSides >= 1) {
          //   // Since the price already including the only 1 print location in the Product Base cost, thus -1 Side from total print locations.
          //   additionalPrintCost = this.ProductCustomizedShopify.printingCost * (this.ProductCustomizedShopify.nbOfSides - 1);

          //   if (!this.IsEmbroideryType) {
          //     additionalPrintCost = this.ProductCustomizedShopify.printingCost * (this.ProductCustomizedShopify.nbOfSides - 1);
          //   } else {
          //     additionalPrintCost = this.EmbroideryCost * (this.ProductCustomizedShopify.nbOfSides);
          //   }
          // }
          //if (this.ProductCustomizedShopify.nbOfSides > 1) {
          //  // Since the price already including the only 1 print location in the Product Base cost, thus -1 Side from total print locations.
          //  additionalPrintCost = this.ProductCustomizedShopify.printingCost * (this.ProductCustomizedShopify.nbOfSides - 1);
          //}

          const selectedStyle = this.selectedProductStyleIds.find(
            (s) => s.styleId == next.StyleId
          );
          let select = false;
          let imageUrl = this.commonService.fn_getImageUrl(
            this.masterProductImgBaseURL +
            this.ProductCustomizedShopify.PngRelativeUrlWithProduct,
            next.StyleName
          );
          if (selectedStyle) {
            select = true;
            // if design id exist that means alternate design exist for this variant or style
            if (selectedStyle.designId) {
              const img = this.ProductCustomizedShopify.Images.find(
                (x) =>
                  x.UniqueStyleId == selectedStyle.uniqueStyleId &&
                  x.IsCustom == false
              );
              if (img) imageUrl = this.masterProductImgBaseURL + img.ImagePath;
            }
          }
          var priceWithPrintCost = 0;
          if (this.IsEmbroideryType) {
            priceWithPrintCost = this.commonService.fn_CalculateTotalCost(
              size.UnitPrice,
              this.finishingCost,
              this.ProductCustomizedShopify.EmbroideryCost,
              this.ProductCustomizedShopify.nbOfSides,
              this.profitPrice,
              this.IsEmbroideryType
            );
          } else {
            priceWithPrintCost = this.commonService.fn_CalculateTotalCost(
              size.UnitPrice,
              this.finishingCost,
              this.ProductCustomizedShopify.printCost,
              this.ProductCustomizedShopify.nbOfSides,
              this.profitPrice
            );
          }
          const discountedPrice = this.commonService.fn_calculateDiscount(
            priceWithPrintCost - this.profitPrice,
            this.ProductCustomizedShopify.DiscountPercent
          );
          current.push({
            select: select,
            styleId: next.StyleId,
            uniqueStyleId: next.UniqueStyleId,
            imageUrl: imageUrl,
            color: next.StyleColor,
            colorName: next.StyleName,
            printCost: this.ProductCustomizedShopify.printCost,
            finishingCost: this.finishingCost,
            sizeName: size.Name,
            uniqueSizeId: size.UniqueSizeId,
            price: size.UnitPrice,
            sideCount: this.ProductCustomizedShopify.nbOfSides,
            retailPrice: priceWithPrintCost, //988
            discountedPrice: discountedPrice, // for shopify only,
          });
        });
        return current;
      },
      []
    );
  }
  fn_getStoreList() {
    this.loader.show();
    this.storeService
      .getStoreList("", 0, 10, true, this.ApplicationUserId, false)
      .subscribe(
        (res) => {
          if (res.StatusCode === 200) {
            this.storeList = res.Data.ResponseData;
            this.loader.hide();
          } else if (res.StatusCode === 204 || res.StatusCode === 404) {
            this.loader.hide();
          }
        },
        (err: any) => {
          this.loader.hide();
          this.errorhandlerService.handleError(err);
        }
      );
  }

  fn_publish() {
    this.productService
      .getCustomizedProductDetailsByProductId(
        this.selectProduct.productId,
        this.designId,
        this.selectedStore
      )
      .subscribe((res: any) => {
        const store: GetStoreListInterface | undefined = this.storeList.find(
          (Res) => {
            return Res.StoreId === this.selectedStore;
          }
        );
      });
    this.loader.show();
    this.storePublishModel = {
      CustomizedProductId: this.ProductCustomized.ID,
      StoreAdminId: this.ApplicationUserId,
      StoreId: [this.selectedStore],
      Tags: JSON.stringify(this.productTags),
      Labels: JSON.stringify(this.productLabels),
    };
    this.storeService
      .saveStorePublishProducts(this.storePublishModel)
      .subscribe(
        (res: any) => {
          if (res.StatusCode === 200) {
            this.notificationService.success(res.Message, "Publish Product");
            this.notificationService.infoAlways(this.sizelabelInfoMessage, "");
            this.updateThePrice(
              this.ProductCustomized.ID.toString(),
              this.selectedStore.toString(),
              this.profitPrice.toString(),
              true,
              null
            );
            this.router.navigate(["store/customizedproducts"]);

            this.loader.hide();
          } else if (res.StatusCode === 203) {
            this.notificationService.info(res.Message, "Publish Product");
            this.loader.hide();
          }
          this.loader.hide();
        },
        (err: any) => {
          this.loader.hide();
          this.errorhandlerService.handleError(err);
        }
      );
  }

  updateThePrice(
    CustomizedProductId: string,
    StoreId: string,
    RetailPrice: string,
    isfirstTime: boolean,
    oldDesignId: string
  ) {
    const PublishedProductUpdateModel = {
      CustomizedProductId: CustomizedProductId,
      UserId: this.ApplicationUserId,
      StoreId: StoreId,
      RetailPrice: RetailPrice,
      FinishingPrice: this.finishingCost.toString(),
      Styles: this.selectedProductStyleIds,
      IsFirstTime: isfirstTime,
      OldDesignId: oldDesignId,
      SizingLabelData: this.SizingLabelData,
    };
    this.storeService
      .UpdateStoreAdminPublishedProductList(PublishedProductUpdateModel)
      .subscribe(
        (res: any) => {
          if (res.StatusCode === 200) {
            this.loader.hide();
          } else if (res.StatusCode === 204 || res.StatusCode === 404) {
            this.loader.hide();
          }
        },
        (err: any) => {
          this.loader.hide();
          this.errorhandlerService.handleError(err);
        }
      );
  }

  fn_SelectPublishProducts(event: any, storeId: number, form: FormGroup) {
    this.selectedStore = storeId;
  }

  addStore() {
    this.selectedStore = 0;
    const dialogRef1 = this.dialog.open(CreateStoreComponent, {});

    dialogRef1.afterClosed().subscribe(() => {
      this.fn_getStoreList();
    });
  }

  SelectProductStyle(
    event: any,
    styleId: number,
    uniqueStyleId: number,
    designId: number
  ) {
    this.dataPricingSize.forEach((x) => {
      if (x.styleId == styleId) {
        x.select = event.checked;
      }
    });
    if (event.checked) {
      const existingIndex = this.selectedProductStyleIds.findIndex(
        (s) => s.styleId == styleId
      );
      if (existingIndex === -1) {
        // Style doesn't exist, add it
        this.selectedProductStyleIds.push({
          styleId: styleId,
          uniqueStyleId: uniqueStyleId,
          designId: designId,
        });
      } else {
        // Style exists - update the designId if the new one is valid
        // This ensures per-style designs from SavedStyles are preserved
        if (designId && designId > 0) {
          this.selectedProductStyleIds[existingIndex].designId = designId;
        }
      }
    } else {
      const index: number = this.selectedProductStyleIds.findIndex(
        (s) => s.styleId == styleId
      );
      this.selectedProductStyleIds.splice(index, 1);
    }
    this.changeDetectorRefs.detectChanges();
  }

  //#region Row span
  spans = [];
  cacheSpan(key, accessor) {
    const DATA = this.dataPricingSize;
    for (let i = 0; i < DATA.length;) {
      let currentValue = accessor(DATA[i]);
      let count = 1;

      // Iterate through the remaining rows to see how many match
      // the current value as retrieved through the accessor.
      for (let j = i + 1; j < DATA.length; j++) {
        if (currentValue != accessor(DATA[j])) {
          break;
        }
        count++;
      }

      if (!this.spans[i]) {
        this.spans[i] = {};
      }

      // Store the number of similar values that were found (the span)
      // and skip i to the next unique row.
      this.spans[i][key] = count;
      i += count;
    }
  }

  getRowSpan(col, index) {
    return this.spans[index] && this.spans[index][col];
  }
  //#endregion

  getStoreBannerImage(store: GetStoreListInterface): string {
    let img = "";
    if (store && store.StoreSetting) {
      img =
        "url(" +
        store.StoreSetting.StoreImageBanner.replace(
          "data:image/'jpg'",
          "data:image/jpeg"
        ) +
        ")";
    }
    return img;
  }

  fn_ShowVariantImage(imageUrl: string, colorName: string) {
    this.dialog.open(this.imageDialog, {
      data: { url: imageUrl, colorName: colorName },
    });
  }

  fn_DesignVariant(row: PricingTable) {
    let productUniqueId = "",
      designId = "",
      styleUniqueId = "";
    if (this.ProductCustomized) {
      productUniqueId = this.ProductCustomized.productUniqueId.toString();
      designId = this.ProductCustomized.designId.toString();
      styleUniqueId = this.ProductCustomized.prices.find(
        (x) => x.StyleId == row.styleId
      ).UniqueStyleId;
    } else if (this.ProductCustomizedShopify) {
      productUniqueId =
        this.ProductCustomizedShopify.productUniqueId.toString();
      designId = this.ProductCustomizedShopify.designId.toString();
      styleUniqueId = this.ProductCustomizedShopify.prices.find(
        (x) => x.StyleId == row.styleId
      ).UniqueStyleId;
    }

    // if alternate design already exist then use this design id
    // Use both styleId and uniqueStyleId for lookup to handle type mismatches
    let selectedStyle = this.selectedProductStyleIds.find(
      (s) => s.styleId == row.styleId || s.uniqueStyleId == row.uniqueStyleId
    );

    // Also check savedStyle in ProductCustomizedShopify for the alternate design ID
    // This is the source of truth from the backend's ProductStyleAlternateDesigns table
    if (this.ProductCustomizedShopify?.savedStyle) {
      const savedStyleEntry = this.ProductCustomizedShopify.savedStyle.find(
        (s) => String(s.UniqueStyleId) == String(row.uniqueStyleId) || String(s.UniqueStyleId) == String(styleUniqueId)
      );
      if (savedStyleEntry && savedStyleEntry.DesignId && savedStyleEntry.DesignId > 0) {
        // Use the alternate design ID from savedStyle (backend source of truth)
        designId = savedStyleEntry.DesignId.toString();
      }
    }

    // Also check selectedProductStyleIds for alternate design (updated during session)
    if (selectedStyle && selectedStyle.designId && selectedStyle.designId > 0) {
      // If selectedProductStyleIds has a different (more recent) design ID, use that
      designId = selectedStyle.designId.toString();
    }

    const selectProduct: InksofteditorInterfaceData = {
      productId: productUniqueId,
      categoryId: "",
      styleId: styleUniqueId,
      designId: designId,
      sizes: null,
      additionalInfo: null,
      sizingLabelExist: null,
    };
    this.designVariantDialogRef = this.dialog.open(this.designVariantDialog, {
      data: { selectProduct, colorName: row.colorName },
    });
  }

  fn_SaveVariantDesign(designData: InksofteditorAPIInterface) {
    this.loader.show();

    let selectedStyle = this.selectedProductStyleIds.find(
      (s) => s.uniqueStyleId == designData.ProductStyleId
    );

    // If style not found in selectedProductStyleIds, add it first
    if (!selectedStyle) {
      // Find the style info from dataPricingSize or ProductCustomizedShopify.prices
      const priceStyle = this.ProductCustomizedShopify?.prices?.find(
        (p: any) => p.UniqueStyleId == designData.ProductStyleId
      ) || this.ProductCustomized?.prices?.find(
        (p: any) => p.UniqueStyleId == designData.ProductStyleId
      );

      if (priceStyle) {
        selectedStyle = {
          styleId: priceStyle.StyleId,
          uniqueStyleId: Number(designData.ProductStyleId),
          designId: designData.ID
        };
        this.selectedProductStyleIds.push(selectedStyle);
      } else {
        // Fallback: create entry with just the uniqueStyleId
        selectedStyle = {
          styleId: 0,
          uniqueStyleId: Number(designData.ProductStyleId),
          designId: designData.ID
        };
        this.selectedProductStyleIds.push(selectedStyle);
      }
    } else {
      selectedStyle.designId = designData.ID;
    }

    // update new image of style
    let row = this.dataPricingSize.find(
      (x) => x.uniqueStyleId == designData.ProductStyleId
    );
    row.imageUrl = null;

    // get inksoft design details
    this.productService
      .getInkoftDesignDetails(environment.api_url_inksoft, designData.ID)
      .subscribe((res: InksoftDesignModel) => {
        this.loader.hide();
        const designDetails = res;

        row.imageUrl =
          this.masterProductImgBaseURL +
          designDetails.Data.Canvases[0].PngRelativeUrlWithProduct;
        try {

          if (this.ProductCustomized) {
            this.ProductCustomized.Images = this.ProductCustomized.Images.filter(
              (x) =>
                !(
                  x.UniqueStyleId == designData.ProductStyleId &&
                  x.IsCustom == false
                )
            );

            designDetails.Data.Canvases.map((ele) => {
              this.ProductCustomized.Images.push({
                UniqueStyleId: designData.ProductStyleId,
                ImagePath: ele.PngRelativeUrlWithProduct,
                IsCustom: false,
              });
            });
          }
        }
        catch { }
        try {

          if (this.ProductCustomizedShopify) {
            this.ProductCustomizedShopify.Images =
              this.ProductCustomizedShopify.Images.filter(
                (x) =>
                  !(
                    x.UniqueStyleId == designData.ProductStyleId &&
                    x.IsCustom == false
                  )
              );


            designDetails.Data.Canvases.map((ele) => {
              this.ProductCustomizedShopify.Images.push({
                UniqueStyleId: designData.ProductStyleId,
                ImagePath: ele.PngRelativeUrlWithProduct,
                IsCustom: false,
              });
            });
          }
        } catch { }
      });

    this.zone.run(() => {
      this.designVariantDialogRef.close(true);
      this.notificationService.success(null, "Design created");
    });
  }
  fn_calculateFinshingCost(finshingPrice: any) {
    if (this.SizingLabelData.EnableSizingLabel) {
      if (
        this.SizingLabelData.AddSizeLevel ||
        this.SizingLabelData.UpdateSizeLevel ||
        this.selectProduct.sizingLabelExist
      ) {
        this.finishingCost = Constants.finishingCost;
      } else {
        if (this.selectProduct.sizingLabelExist)
          this.finishingCost = Constants.finishingCost;
        else this.finishingCost = finshingPrice == null ? 0 : finshingPrice;
      }
    } else {
      this.finishingCost = 0;
    }
  }
  fn_getMySavedDesign() {
    this.savedDesignFilter.Take = 10;
    this.savedDesignFilter.Skip = this.savedSizeLabelCount;
    this.productservice
      .getMySavedDesign(this.savedDesignFilter)
      .subscribe((res: any) => {
        if (res.StatusCode == 200) {
          if (res.Data.ResponseData.length > 0) {
            res.Data.ResponseData.forEach((obj: any) => {
              if (
                !this.mySavedDesignList.find((x) => x.DesignId === obj.DesignId)
              )
                this.savedSizeLabelCount = this.mySavedDesignList.push(obj);
            });
            if (this.mySavedDesignList.length < this.savedDesignFilter.Take) {
              this.isSavedSizeLabelDisplayed = true;
            }
          }
        }
      });
  }

  fn_SetMySaveDesignData(designId: any) {
    var selectedLabel = this.mySavedDesignList.find(
      (x) => x.DesignId == designId
    );
    //rest data will be filled during coming to this section from save design
    //or after click next button from here
    this.SizingLabelData = {
      ...this.SizingLabelData,
      Tagline1: selectedLabel.TagLine1,
      Tagline2: selectedLabel.TagLine1,
      FontStyle: selectedLabel.FontStyle,
    };
    this.canvasComp.selectSizeLabel(selectedLabel.SizingLabelLogo);
  }

  fn_displayColumn(event: any) {
    if (event.checked) {
      this.loader.show();
      this.flag = true;
      this.isDisabled = true;
      this.displayedColumns = [
        "select",
        "color",
        "colorName",
        "sizeName",
        "price",
        "retailPrice",
        "showQuantityEnabled",
        "totalbulkPrice",
      ];

      this.productService.fn_GetBulkOrderDiscount().subscribe((res: any) => {
        if (res.StatusCode == 200) {
          this.BulkDiscount = res.Data.ResponseData;
          this.loader.hide();
        }
      });
    } else {
      this.displayedColumns = [
        "select",
        "color",
        "colorName",
        "sizeName",
        "price",
        "retailPrice",
      ];
    }
  }
  fn_CreateBulkOrder(data: IClientAuthorizeCallbackData) {
    this.loader.show();
    this.zone.run(() => {
      this.loader.show();
    });
    this.totalCosttoCharge =
      this.totalCosttoCharge -
      (this.totalCosttoCharge * this.decPercentage) / 100;
    const BulkQrder = {
      CustomizedProductId: this.ProductCustomized.ID,
      DesignId: this.ProductCustomized.designId,
      Title: this.ProductCustomized.name,
      ProductId: Number(this.ProductCustomized.productUniqueId),
      FinishingPrice: this.finishingCost,
      IsEmbroideryType: this.IsEmbroideryType,
      PrintingCost: this.IsEmbroideryType
        ? this.EmbroideryCost
        : Constants.PrintingCostPrice,
      TotalPrice: this.totalCosttoCharge,
      InventoryItem: [],
      BulkDiscount: this.decPercentage,
      PaymentId: data.id,
      PayPalPayerId: data.payer.payer_id,
      PayPalOrderId: data.id,
      RetailPrice: this.ProductCustomized.prices[0].Sizes[0].UnitPrice,
      UserId: Number(this.ApplicationUserId),
      Profit: this.profitPrice,
      EmbroiderySetUpCost: this.EmbroiderySetUpCost,
      SizingLabelData: this.SizingLabelData,
    };
    this.dataPricingSize.forEach((x) => {
      if (x.bulkPerSizeQuantity > 0) {
        BulkQrder.InventoryItem.push({
          BulkPrice: x.bulkPrice,
          Quantity: Number(x.bulkPerSizeQuantity),
          SizeId: Number(x.uniqueSizeId),
          UniqueStyleId: x.uniqueStyleId,
          ColorName: x.colorName,
          Discount: this.decPercentage,
          ColorCode: x.color.toString(),
          SizeName: x.sizeName,
          UnitPrice: x.retailPrice,
        });
      }
    });

    this.productService.fn_CreateBulkOrder(BulkQrder).subscribe((res: any) => {
      if (res.StatusCode == 200) {
        this.loader.hide();
        this.notificationService.success(res.Message, "Success");
        this.router.navigate(["store/customizedproducts"]);
      }
    });
  }
  displayColor(obj: any) {
    return {
      "background-color": obj,
    };
  }

  fn_GetBulkProductSummary() {
    this.loader.show();
    this.productService
      .fn_GetBulkProductSummary(this.ProductCustomized.ID)
      .subscribe((res: any) => {
        if (res.StatusCode == 200) {
          this.listSummary = res.Data.ResponseData;
          this.loader.hide();
        }
      });
  }

  fn_calculateBulkPrice(data: any, quantity: number) {
    // this.loader.show()

    this.dataPricingSize.forEach((x) => {
      if (x.uniqueSizeId == data.uniqueSizeId) {
        if (quantity >= 1) {
          x.totalbulkPrice = x.bulkPrice * Number(quantity);
          x.bulkPerSizeQuantity = Number(quantity);
        } else {
          x.totalbulkPrice = x.bulkPrice * 1;
          x.bulkPerSizeQuantity = 0;
        }
      }
    });

    this.calculateTotal();
    this.changeDetectorRefs.detectChanges();
  }

  goto() {
    if (this.profitPrice == 0) {
      this.notificationService.error(
        "Profit must be greater than zero",
        "Validation error"
      );
    }
    let totalquantityAmount = this.totalqunatity || 0;
    if (totalquantityAmount <= 10) {
      this.notificationService.error(
        "Please enter  minimum 10 quantity for bulk order",
        "Validation error"
      );
    } else {
      this.nextPanel("payment");
      this.fn_PaypalInitConfig();
    }
  }

  public calculateTotal() {
    this.totalQuantity = Number(
      this.dataPricingSize.reduce(
        (accum, curr) => accum + curr.bulkPerSizeQuantity,
        0
      )
    );
    this.decPercentage = this.BulkDiscount.filter(
      (x) => x.MinQty <= this.totalQuantity && x.MaxQty >= this.totalQuantity
    ).map((x) => x.DiscountPercentage)[0];
    if (!this.decPercentage) this.decPercentage = 0;
    this.totalCost = this.dataPricingSize
      .filter(({ bulkPerSizeQuantity }) => bulkPerSizeQuantity > 0)
      .reduce((accum, curr) => accum + curr.totalbulkPrice, 0);
    this.totalqunatity = this.dataPricingSize
      .filter(({ bulkPerSizeQuantity }) => bulkPerSizeQuantity > 0)
      .reduce((accum, curr) => accum + curr.bulkPerSizeQuantity, 0);
    this.discountedPrice = Number(
      ((this.totalCost * this.decPercentage) / 100).toFixed(2)
    );
    this.totalCosttoCharge = Number(
      (this.totalCost - this.discountedPrice).toFixed(2)
    );
    if (this.IsEmbroideryType)
      this.totalCosttoCharge = Number(
        (this.totalCosttoCharge + this.EmbroiderySetUpCost).toFixed(2)
      );
  }

  fn_PaypalInitConfig(): void {
    this.payPalConfig = {
      currency: "USD",
      clientId: environment.paypalPublicKey,
      createOrderOnClient: (data): ICreateOrderRequest => {
        return {
          intent: "CAPTURE",
          application_context: {
            brand_name: "MerchLoop",
            shipping_preference: "NO_SHIPPING",
          },
          purchase_units: [
            {
              amount: {
                currency_code: "USD",
                value: this.cp
                  .transform(this.totalCosttoCharge, "", "", "1.2-2")
                  .toString(),
                breakdown: {
                  item_total: {
                    currency_code: "USD",
                    value: this.cp
                      .transform(this.totalCosttoCharge, "", "", "1.2-2")
                      .toString(),
                  },
                },
              },
              items: [
                {
                  name: this.ApplicationUserId,
                  quantity: "1",
                  category: "PHYSICAL_GOODS",
                  unit_amount: {
                    currency_code: "USD",
                    value: this.cp
                      .transform(this.totalCosttoCharge, "", "", "1.2-2")
                      .toString(),
                  },
                },
              ],
            },
          ],
        };
      },
      advanced: {
        commit: "true",
      },
      style: {
        label: "pay",
        layout: "horizontal",
      },

      onApprove: (data, actions) => { },
      onClientAuthorization: (data: IClientAuthorizeCallbackData) => {
        this.zone.run(() => {
          if (
            !this.IsBulkUploadType &&
            this.IsEmbroideryType &&
            !this.isEditCase
          ) {
            this.fn_PaymentSuccess(data);
          } else {
            this.fn_CreateBulkOrder(data);
          }
        });
      },
      onCancel: (data, actions) => {
        this.notificationService.info(
          "Your transaction has been cancelled",
          "Payment"
        );
      },
      onError: (err) => {
        // this.router.navigate([this.parentRouteParam + '/paymentfailed']);
        // window.location.reload();
      },
      onClick: (data, actions) => { },
    };
  }

  updateBulkPricing() {
    this.dataPricingSize.forEach((size) => {
      if (!this.IsEmbroideryType) {
        this.additionalPrintCost =
          size.printCost * (this.ProductCustomized.nbOfSides - 1);
      } else {
        this.additionalPrintCost =
          this.EmbroideryCost * (this.ProductCustomized.nbOfSides - 1);
      }
      const priceWithPrintCost =
        size.price + this.additionalPrintCost + this.finishingCost;
      size.retailPrice = priceWithPrintCost + this.profitPrice;
    });
  }

  gotoPayment() {
    if (this.profitPrice == 0) {
      this.notificationService.error(
        "Profit must be greater than zero",
        "Validation error"
      );
    } else {
      this.nextPanel("payment");
      this.totalCosttoCharge = this.EmbroiderySetUpCost;
      this.fn_PaypalInitConfig();
    }
  }
  fn_PaymentSuccess(data: IClientAuthorizeCallbackData) {
    this.loader.show();
    this.manualPayment.PaymentId = data.id;
    this.manualPayment.PayerId = data.payer.payer_id;
    this.manualPayment.DesignId = this.designId;
    this.productservice
      .fn_SetManualPaymentForEmbroideryProduct(this.manualPayment)
      .subscribe(
        (res: any) => {
          this.loader.show();
          if (res.StatusCode === 200) {
            this.notificationService.success(res.Message, "Success");
            this.nextPanel("selectStore");
            this.loader.hide();
          } else {
            this.notificationService.error(res.Message, "error");
            this.selectStorePanel();
          }
        },
        (err: any) => {
          this.loader.hide();
        }
      );
  }

  GoBack() {
    //this.flag = true;
    //this.isDisabled = true;
    //this.displayedColumns = ['select', 'color', 'colorName', 'sizeName', 'price', 'retailPrice', 'showQuantityEnabled', 'totalbulkPrice'];
    this.IsBulkUploadOrder = false;
    this.totalCost = 0;
    this.discountedPrice = 0;
    this.changeDetectorRefs.detectChanges();
    this.nextPanel("pricing");
  }



  loginInksoft() {

    this.localStorage.remove("inksoftToken");
    let storeId = this.activatedRoute.snapshot.queryParams["storeId"];
    this.inksoftService.loginInksoft(storeId).subscribe(
      (res: any) => {
        if (res.StatusCode === 200) {
          this.localStorage.set(
            "inksoftToken",
            res.Data.LoginResponseModel.tokenInksoft
          );
          this.shopifyStoreApiKey = res.Data.ResponseData.ApiKey;
          this.storeOwnerUserId = res.Data.LoginResponseModel.UserId;
          this.ApplicationUserId = this.storeOwnerUserId;
          this.superadminUserId = localStorage.getItem("userId");
          this.storeIdForEdit = storeId;
        } else {
          this.notificationService.error(res.Message, "error");
        }
        // Mark InkSoft login as complete and navigate to editor if pending
        this.inksoftReady = true;
        if (this.pendingEditorNavigation) {
          this.pendingEditorNavigation = false;
          this.nextPanel("customizeProduct");
        }
      },
      (err: any) => {
        console.error('loginInksoft failed:', err);
        this.notificationService.error('Failed to connect to InkSoft. Please try again.', 'Error');
        this.inksoftReady = true;
        if (this.pendingEditorNavigation) {
          this.pendingEditorNavigation = false;
          this.nextPanel("customizeProduct");
        }
      }
    );
  }

  mapShopifyRequestDataForAddProduct() {

    this.shopifyRequestData = {
      product: {
        title: this.detailText.text,
        body_html: this.getProductDescription(),
        vendor: "Merchloop",
        product_type: "Clothes",
        tags: this.fn_GetTags(),
        metafields: this.fn_GetMetaFields(),
        options: [
          {
            name: "Color",
            values: this.dataPricingSize
              .filter(
                (ele, index) =>
                  this.dataPricingSize.findIndex(
                    (obj) => obj.colorName === ele.colorName
                  ) === index
              )
              .map((x) => x.colorName),
          },
          {
            name: "Size",
            values: this.ProductCustomizedShopify.prices[0].Size.map(
              (size) => size.Name
            ),
          },
        ],
        variants: this.dataPricingSize.reduce((init, sty) => {
          let price = 0;
          if (this.IsEmbroideryType)
            price = this.commonService.fn_CalculateTotalCost(
              sty.price,
              this.finishingCost,
              this.EmbroideryCost,
              sty.sideCount,
              this.profitPrice,
              this.IsEmbroideryType
            );
          else
            price = this.commonService.fn_CalculateTotalCost(
              sty.price,
              this.finishingCost,
              sty.printCost,
              sty.sideCount,
              this.profitPrice
            );
          // Shopify saves price and cost SEPARATELY: `price` is the selling price (incl. profit) and
          // `cost` is the "Cost per item" (COGS) = product cost WITHOUT the store profit. Shopify then
          // shows the real profit as (price - cost). Do NOT apply the store DiscountPercent to the COGS:
          // SOP-hosted stores use DiscountPercent = 100, which zeroed the cost on every variant so Shopify
          // reported the whole price as profit (100% margin).
          let cost = price - this.profitPrice;
          const varient = {
            option1: sty.colorName,
            option2: sty.sizeName,
            inventory_policy: "continue",
            price: price.toFixed(2),
            cost: cost.toFixed(2),
            uniqueStyleId: Number(sty.uniqueStyleId),
            uniqueSizeId: Number(sty.uniqueSizeId),
          };
          if (
            this.selectedProductStyleIds.some((s) => s.styleId == sty.styleId)
          ) {
            return [...init, varient];
          } else {
            return init;
          }
        }, []),
        images: [
          {
            // Stored value is an absolute Azure Blob URL post-migration; no host prefix needed.
            src: this.ProductCustomizedShopify.PngRelativeUrlWithProduct,
          },
        ],
      },
      productid: Number(this.designId),
      Product_Id: this.ProductCustomizedShopify.productUniqueId,
      StoreId: this.activatedRoute.snapshot.queryParams["storeId"],
      apiKey: this.shopifyStoreApiKey,
      VariantImages: this.dataPricingSize.reduce((init, sty) => {
        let styleImages = this.ProductCustomizedShopify.Images.filter(
          (x) => x.UniqueStyleId == sty.uniqueStyleId && x.IsCustom == false
        ).map((x) => this.masterProductImgBaseURL + x.ImagePath);
        if (
          this.selectedProductStyleIds.some((s) => s.styleId == sty.styleId) &&
          styleImages &&
          styleImages.length > 0 &&
          !init.find((x) => x.StyleName == sty.colorName)
        ) {
          return [
            ...init,
            {
              StyleName: sty.colorName,
              Images: styleImages,
            },
          ];
        } else {
          return init;
        }
      }, []),
    };
  }
  updateDesignWithSelectedColorsFnForAddProduct(
    designID: number
  ): UpdateDesignWithSelectedColors {
    const colors = this.ProductCustomizedShopify.prices.reduce((init, sty) => {
      if (this.selectedProductStyleIds.some((s) => s.styleId == sty.StyleId)) {
        return [...init, ...sty.StyleColor];
      } else {
        return init;
      }
    }, []);
    return {
      DesignId: designID,
      ShopifyProfit: this.profitPrice,
      ColorsJson: JSON.stringify(colors),
      StoreId: this.activatedRoute.snapshot.queryParams["storeId"],
      SizingLabelData: this.SizingLabelData,
      FinishingPrice: this.finishingCost,
      UserId: this.ApplicationUserId,
      Styles: this.selectedProductStyleIds,
      CreatedBy: this.superAdminLoggedIn
        ? this.superadminUserId
        : this.ApplicationUserId,
      Metadata: this.fn_GetMetaFieldsToSaveInDb(),
      Tags: this.fn_GetTagsToSaveInDb(),
    };
  }
  fn_AddProductToShopify() {
    var colorsData = this.updateDesignWithSelectedColorsFnForAddProduct(
      this.designId
    );
    this.loader.show();

    this.productService.updateCustomizedDesign(colorsData).subscribe(
      async (res) => {

        if (res.StatusCode == 200) {

          //get here the exact images to be passed to shopify
          this.ProductCustomizedShopify.Images = res.Data.ResponseData1;
          this.mapShopifyRequestDataForAddProduct();

          // Fetch store's assigned collection and add to request
          const addStoreId = this.activatedRoute.snapshot.queryParams["storeId"] || this.storeIdForEdit;
          if (addStoreId) {
            try {
              const colRes: any = await this.shopifyCollectionService.getStoreCollectionId(Number(addStoreId)).toPromise();
              if (colRes?.StatusCode === 200 && colRes?.Data?.ResponseData) {
                this.shopifyRequestData.shopifyCollectionId = colRes.Data.ResponseData;
              }
            } catch (e) {}
          }

          // ===== SHOPIFY PUBLISH TEMPORARILY DISABLED =====
          // We only save the customized product in the DB (updateCustomizedDesign above, IsActive stays true)
          // and do NOT push it to Shopify. Uncomment the block below to re-enable Shopify publishing.
          this.loader.hide();
          const storeId =
            this.activatedRoute.snapshot.queryParams["storeId"];
          const storeName =
            this.activatedRoute.snapshot.queryParams["storeName"];
          this.notificationService.success(
            "Product saved successfully (Shopify publish disabled)",
            "Success"
          );
          this.router.navigate([
            "superadmin/shopify-products",
            storeId,
            storeName,
          ]);
          /* ===== Shopify publish disabled - original code kept for re-enable =====
          this.productService
            .addProductInShopify(this.shopifyRequestData)
            .subscribe(
              (res) => {
                this.loader.hide();
                if (res && res.product && res.product.id) {
                  const storeId =
                    this.activatedRoute.snapshot.queryParams["storeId"];
                  const storeName =
                    this.activatedRoute.snapshot.queryParams["storeName"];
                  this.notificationService.success(
                    "Product successfully added in shopify",
                    "Success"
                  );
                  this.router.navigate([
                    "superadmin/shopify-products",
                    storeId,
                    storeName,
                  ]);
                } else if (res && res.err == 403) {
                  this.notificationService.error(res.message, "Error");
                }
              },
              (err: any) => {
                this.loader.hide();
                this.errorhandlerService.handleError(err);
              }
            );
          ===== end Shopify publish disabled ===== */
        }
      },
      (err: any) => {
        this.loader.hide();
        this.errorhandlerService.handleError(err);
      }
    );
  }

  onColorInputChange(event: any, item: any, type: string) {
    const color = event.target.value;
    if (type === "background") {
      item.backgroundColor = color;
    } else if (type === "text") {
      item.textColor = color;
    }
  }

  fn_RemoveLabel(index: number) {
    this.productLabels.splice(index, 1);
  }

  fn_AddLabel() {
    if (this.productLabels.length >= 3) return;
    else
      this.productLabels.push({
        text: "",
        backgroundColor: "#24afb2",
        textColor: "#ffffff",
      });
  }

  fn_RemoveTag(index: number) {
    // Prevent deletion of default tag (decoration type)
    if (this.productTags[index].isDefault) {
      return;
    }
    this.productTags.splice(index, 1);
  }

  fn_AddTag() {
    if (this.productTags.length >= 15) return;
    else this.productTags.push({ tagtext: "" });
  }
  fn_GetMetaFieldsToSaveInDb() {
    let labelInfo = [];
    if (this.productLabels.length == 1 && !this.productLabels[0].text) {
    } else {
      for (let i = 0; i < this.productLabels.length; i++) {
        if (this.productLabels[i].text) {
          labelInfo.push(this.productLabels[i]);
        }
      }
    }
    if (labelInfo.length == 0) return null;
    else return JSON.stringify(labelInfo);
  }

  fn_GetTagsToSaveInDb() {
    let tagInfo = [];
    if (this.productTags.length == 1 && !this.productTags[0].tagtext) {
    } else {
      for (let i = 0; i < this.productTags.length; i++) {
        if (this.productTags[i].tagtext) {
          // Remove isDefault flag before saving to database
          tagInfo.push({ tagtext: this.productTags[i].tagtext });
        }
      }
    }
    if (tagInfo.length == 0) return null;
    else return JSON.stringify(tagInfo);
  }

  fn_GetMetaFields() {
    let getValue = this.fn_GetMetaFieldsToSaveInDb();

    if (getValue == null) return null;
    else {
      var metafield = null;
      if (this.metaFieldId) {
        metafield = [
          {
            id: this.metaFieldId,
            type: "json",
            value: getValue,
          },
        ];
      } else {
        metafield = [
          {
            key: "product_label",
            type: "json",
            namespace: "custom",
            value: getValue,
          },
        ];
      }
      return metafield;
    }
  }
  fn_GetTags() {
    let tagInfo = [];
    if (this.productTags.length == 1 && !this.productTags[0].tagtext) {
    } else {
      for (let i = 0; i < this.productTags.length; i++) {
        if (this.productTags[i].tagtext) {
          // Only push the tagtext value (ignore isDefault flag)
          tagInfo.push(this.productTags[i].tagtext);
        }
      }
    }

    if (tagInfo.length == 0) return null;
    else {
      let tags = tagInfo.join(",");
      return tags;
    }
  }

  /** Select editor: Inksoft or Design Huddle */
  selectEditor(editor: 'inksoft' | 'designhuddle') {
    this.selectedEditor = editor;
    this.editorSelected = true;
  }

  /** Handle Design Huddle project created event */
  fn_SaveDesignHuddleProject(projectData: any) {
    this.zone.run(() => {
      this.loader.show();
    });

    // Store Design Huddle project ID
    if (this.isEditCase) {
      this.designIdNew = projectData.projectId;
    } else {
      this.designId = projectData.projectId;
    }

    // Design Huddle's CreateProject already creates the CustomizedProduct in the backend.
    // Skip loopToSaveDesign (which calls InkSoft API and fails for Design Huddle IDs).
    this.updatePricePanel();
    this.loader.hide();

    this.buildSizingData();
    if (this.SizingLabelData.EnableSizingLabel) {
      this.nextPanel("sizingLabel");
    } else {
      this.nextPanel("pricing");
    }
  }

  getProductDescription() {
    let desc = this.detailText.description;
    let sizeArr = this.productSizeGuide;
    let supplier = this.productSupplier;
    let tableRow = "";
    let table = "";
    let alignedDesc = "";
    let liDesc = "";
    if (sizeArr && sizeArr.length > 0) {
      sizeArr.forEach((item: any) => {
        tableRow =
          tableRow +
          `<tr>
                  <td><strong>` +
          item.SizeName +
          `</strong></td>
                  <td>` +
          item.Width +
          `</td>
                  <td>` +
          item.Length +
          `</td>
                  <td>` +
          item.SleeveLength +
          `</td>
                  </tr>`;
      });
      table =
        `<br><p><strong>Size chart:</strong></p><div class="table-responsive dynamic" data-unit-system="imperial">
                <table cellpadding="5">
                <tbody><tr>
                <td>&nbsp;</td>
                <td><strong>W (in)</strong></td>
                <td><strong>L (in)</strong></td>
                <td><strong>SL (in)</strong></td>
                </tr> ` +
        tableRow +
        `</tbody></table>
                <small style="font-size:10px"><strong>Note</strong><span style="color: red">*</span>: W (Width), L (Length), SL (Sleeve length)</small>
                </div>
                `;
    }

    if (supplier == "alphabroder") {
      desc.split(";").forEach((item: any) => {
        liDesc = liDesc + "<li>" + item + "</li>";
      });
    } else if (supplier == "S&S Activewear") {
      desc.split(",").forEach((item: any) => {
        liDesc = liDesc + "<li>" + item + "</li>";
      });
    } else if (supplier == "Sanmar") {
      desc.split(",").forEach((item: any) => {
        liDesc = liDesc + "<li>" + item + "</li>";
      });
    }
    alignedDesc = "<ul>" + liDesc + "</ul";
    let html = "<p><strong>Description: </strong></p>" + alignedDesc + table;
    return html;
  }
}
